import { Parser, ParseResult } from "../types";
import { parseEnvFile } from "../../../services/utils";

export const envParser: Parser = {
  name: "env",
  priority: 1,
  parse: (content: string): ParseResult<Record<string, unknown>> => {
    try {
      const parsed = parseEnvFile(content);
      if (Object.keys(parsed).length === 0) {
        return { success: false, data: null, format: "env", error: "No valid entries found" };
      }
      return { success: true, data: parsed, format: "env" };
    } catch (e) {
      return { success: false, data: null, format: "env", error: e.message };
    }
  },
};
